import { capitalCase } from "change-case";
export default {
  data: () => ({
    permissionTypes: ["View"],
    activitySection: null,
  }),
  computed: {
    user_permissions() {
      return this.$store.getters.user_permissions;
    },
    activitySections() {
      return this.$store.state.orderType.items
        .filter((x) => x.name)
        .map(({ id, name }) => {
          name = capitalCase(name);
          return {
            id,
            name,
          };
        });
    },
  },

  watch: {},
  created() {
    this.$store.dispatch("orderType/fetchAll");
  },
  mounted() {},

  methods: {},
};
